import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { ConfigProvider } from 'antd';
import { theme } from './styles/theme';
import Layout from './components/Layout';
import Home from './pages/Home';
import ProductList from './pages/ProductList';
import ProductDetail from './pages/ProductDetail';
import SearchPage from './pages/Search';
import GlobalStyle from './styles/GlobalStyle';

const antTheme = {
  token: {
    colorPrimary: theme.colors.primary,
    borderRadius: 6,
  },
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <ConfigProvider theme={antTheme}>
        <Router>
          <GlobalStyle />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/products" element={<ProductList />} />
              <Route path="/products/:id" element={<ProductDetail />} />
              <Route path="/search" element={<SearchPage />} />
            </Routes>
          </Layout>
        </Router>
      </ConfigProvider>
    </ThemeProvider>
  );
}

export default App;
